export default "__VITE_ASSET__CZ8W4VN4__"